import { render, staticRenderFns } from "./ring-diagram.vue?vue&type=template&id=7be31a49&scoped=true&"
import script from "./ring-diagram.vue?vue&type=script&lang=js&"
export * from "./ring-diagram.vue?vue&type=script&lang=js&"
import style0 from "./ring-diagram.vue?vue&type=style&index=0&id=7be31a49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be31a49",
  null
  
)

export default component.exports